import { Plugin } from '@nuxt/types';
import credentialStorageInstance from '~/api/credential-storage-instance';

// TODO: This AuthInit only executed once, and only supports client-side
const AuthInit: Plugin = async ({ store, req }) => {
  await credentialStorageInstance.fetchIdentity();
  await store.dispatch('initSharedConfig', { originalUrl: req?.originalUrl, force: false });
};

export default AuthInit;
